import React from 'react'
import ReactFlow, { Controls } from 'react-flow-renderer'


class DocGraph extends React.Component {
    static defaultProps = {
        id: '',
        currentGraphId: 'none',

        style: { height: 200 },
        elements: [],
        classColumn: ' col-12 '
    }

    render() {
        let { id } = this.props;
        let show = this.props.id === this.props.currentGraphId;
        if (this.props.id) { console.log(this.props); }
        return (
            <div>
                <div >
                    {show && <ReactFlow id={`graph ${id}`}
                        className={this.props.classColumn + 'border-info'}
                        style={this.props.style}
                        elements={this.props.elements} >
                        <Controls showInteractive={false} />
                    </ReactFlow>}
                </div>
            </div>)

    }
}

export default DocGraph;
export { DocGraph }